exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[data-v-36fa3810] {\n  font-size: 0.75rem;\n  line-height: 0.75rem;\n}\ninput[data-v-36fa3810]::-webkit-input-placeholder {\n  /* WebKit browsers */\n  line-height: 1.2em;\n}\n.Odiv[data-v-36fa3810] {\n  position: absolute;\n  width: 100%;\n  height: 94%;\n  top: 0;\n  left: 0;\n  line-height: 2.6rem;\n  background: white;\n  font-size: 0.75rem;\n}\n.rightChildren[data-v-36fa3810] {\n  position: absolute;\n  z-index: 99;\n  right: 0;\n  top: 0;\n  line-height: 2.6rem;\n}", ""]);

// exports
